import { Alert, Stack, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

import { PriorityRequestsFilterBar } from "./components/filter/PriorityRequestsFilterBar";
import { PriorityRequestsTable } from "./components/table/PriorityRequestsTable";
import { usePriorityRequestActions } from "./hooks/usePriorityRequestActions";
import { usePriorityRequests } from "./hooks/usePriorityRequests";

export function PriorityRequests() {
  const { t } = useTranslation();
  const { filters, changeFilters, rows, isLoading, isError, isEmpty, paginationResetKey } = usePriorityRequests();
  const actions = usePriorityRequestActions();

  return (
    <Stack spacing={3} sx={{ height: "100%" }} pb={3}>
      <Typography variant="h1">{t("priorityRequests.title")}</Typography>
      <PriorityRequestsFilterBar filters={filters} onChange={changeFilters} />

      {isError && <Alert severity="error">{t("priorityRequests.error")}</Alert>}

      {isEmpty && (
        <Typography color="text.secondary" role="status">
          {t("priorityRequests.empty")}
        </Typography>
      )}

      {!isError && !isEmpty && (
        <Stack sx={{ overflow: "auto", flex: 1, minHeight: 0 }}>
          <PriorityRequestsTable
            rows={rows}
            isLoading={isLoading}
            paginationResetKey={paginationResetKey}
            actions={actions}
          />
        </Stack>
      )}
    </Stack>
  );
}
